import type { CallMediaType } from '../types/voice-call'
import { callAudioRouteArbiter } from './call-audio-route-arbiter'
import { isMobileWeb, isNativeApp } from './platform'

export { callAudioRouteArbiter } from './call-audio-route-arbiter'
export type {
  CallAudioPhase,
  HardwareAudioRoute,
  RouteCorrection,
  UserAudioOutput,
} from './call-audio-route-arbiter'

/** Live desired loudspeaker flag from the call-audio route arbiter. */
export function desiredCallSpeakerOn(): boolean {
  return callAudioRouteArbiter.desiredSpeakerOn()
}

/**
 * Platform/context matrix for the in-call audio output:
 *
 * | Context                               | Default output | Chip shown? |
 * |---------------------------------------|----------------|-------------|
 * | Desktop web — voice AND video         | loud speaker   | if setSinkId |
 * | Mobile web — voice                    | loud speaker   | yes          |
 * | Mobile web — video                    | loud speaker   | no           |
 * | Native app — voice                    | earpiece       | yes          |
 * | Native app — video                    | loud speaker   | yes          |
 *
 * `isSpeakerOn === true` means the loud/media speaker; `false` means the
 * earpiece/ear speaker.
 */

/** Default speakerphone state applied when a call connects. */
export function defaultSpeakerOn(mediaType: CallMediaType): boolean {
  // The only context that should default to the quiet earpiece is a native
  // voice call (phone held to the ear). Everything else uses the loud speaker.
  if (isNativeApp() && mediaType === 'voice') return false
  return true
}

/**
 * Whether the in-call audio-route chip should be offered.
 *
 * Native (voice AND video): always — users must see AirPods / car / earpiece.
 * Mobile web: voice only (earpiece toggle + sink picker when the browser allows).
 * Desktop web: hidden here; the route control self-hides if setSinkId is missing.
 */
export function showSpeakerToggle(mediaType: CallMediaType): boolean {
  if (isNativeApp()) return true
  if (mediaType !== 'voice') return false
  return isMobileWeb()
}
